import { deprecated } from '../../utils/prop-types/deprecated';
export const globalStylesPropTypes = {
    rootSelector: deprecated('^2.0.0'),
    rootTheme: deprecated('^2.0.0'),
};
//# sourceMappingURL=GlobalStyles.types.js.map